<template>
  <div class="restaurant-orders">
    <div class="row my-3">
      <h2 class="">{{ $t('restOrders.ordersTitle') }} {{ this.RESTAURANT.title }}
      <span v-if="this.ordersAreLoading" class="d-inline-block ms-1 spinner-border spinner-border-sm h4 fw-normal text-success" role="status">
        <span class="visually-hidden">Loading...</span>
      </span>
      </h2>
    </div>
    <div class="row pb-4">
      <div class="d-flex align-items-center justify-content-between">
        <div>
          <button @click="updateOrders" class="btn btn-sm btn-outline-secondary me-2">
            <svg width="1.3rem" height="1.3rem" fill="currentColor">
              <use xlink:href="../../assets/ico/bootstrap-icons.svg#arrow-repeat"/>
            </svg>
          </button>
          <button @click="pullingChange" class="btn btn-sm btn-outline-secondary me-2">
            <svg width="1.3rem" height="1.3rem" fill="currentColor">
              <use v-if="!this.ORDER_PULLING" xlink:href="../../assets/ico/bootstrap-icons.svg#play-fill"/>
              <use v-else xlink:href="../../assets/ico/bootstrap-icons.svg#stop-fill"/>
            </svg>
          </button>
          <div class="d-inline-block" v-if="this.ORDER_PULLING" data-bs-toggle="tooltip" data-bs-placement="top" :title="$t('restOrders.autoupdateEnabled')">
            {{pullingTime}}
          </div>
        </div>
        <div>
          <select v-model="pageSize" class="form-select form-select-sm" aria-label="Default select example">
            <option value="10" selected>10</option>
            <option value="20">20</option>
            <option value="30">30</option>
          </select>
        </div>
      </div>
    </div>
    <div class="table-responsive-md pb-4">
      <table class="table table-hover table-orders"
      :class="this.ordersAreLoading ? 'opacity-25' : ''">
        <thead>
        <tr>
          <th scope="col">#</th>
          <th scope="col">{{ $t('restOrders.order.date') }}</th>
          <th scope="col">{{ $t('restOrders.order.items') }}</th>
          <th scope="col" class="text-end">{{ $t('restOrders.order.amount') }}</th>
          <th scope="col" class="text-center">{{ $t('restOrders.order.paid') }}</th>
          <th scope="col">{{ $t('restOrders.order.payment') }}</th>
          <th scope="col">{{ $t('restOrders.order.delivery') }}</th>
          <th scope="col">{{ $t('restOrders.order.status') }}</th>
          <th scope="col"></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(order, index) in this.ordersPages[this.pageIndexSelect]" :key="order.id"
            class="orders__item">
          <th @click="openOrder(order)" scope="row">{{ order.id }}</th>
          <td @click="openOrder(order)">{{ friendlyTime(order.date_created) }}</td>
          <td @click="openOrder(order)">
            {{ order.menu_items_qty }}
            <svg v-show="order.was_updated"
                 data-bs-toggle="tooltip" data-bs-placement="top" :data-bs-title="$t('restOrders.orderWasChangd')"
                 class="ms-2 bi fs-4" width="1rem" height="1rem" fill="gray">
              <use xlink:href="../../assets/ico/bootstrap-icons.svg#pencil-fill"/>
            </svg>
            <svg v-show="order.comment"
                 data-bs-toggle="tooltip" data-bs-placement="top" :data-bs-title="order.comment"
                 class="ms-2 bi fs-4" width="1rem" height="1rem" fill="gray">
              <use xlink:href="../../assets/ico/bootstrap-icons.svg#chat-left-text"/>
            </svg>
          </td>
          <td @click="openOrder(order)" class="text-end">{{ order.amount }}{{ $t('restOrders.currency') }}</td>
          <td @click="openOrder(order)" class="text-center">{{ order.paid }}</td>
          <td @click="openOrder(order)">
            <div v-if="order.payment_method === 'card'" class="d-flex flex-nowrap align-items-center">
              <svg class="bi fs-4 delete-product-ico" width="1.3rem" height="1.3rem" fill="black">
                <use xlink:href="../../assets/ico/bootstrap-icons.svg#credit-card"/>
              </svg>
              <span class="ps-1 ">{{ $t('restOrders.byCard') }}</span>
            </div>
            <div v-else-if="order.payment_method === 'cash'" class="d-flex flex-nowrap align-items-center">
              <svg class="bi fs-4 delete-product-ico" width="1.3rem" height="1.3rem" fill="green">
                <use xlink:href="../../assets/ico/bootstrap-icons.svg#cash-stack"/>
              </svg>
              <span class="ps-1">{{ $t('restOrders.byCash') }}</span>
            </div>
            <div v-else>
              error
            </div>
          </td>
          <td @click="openOrder(order)">
            <div v-if="order.delivery_method === 'delivery'" class="d-flex flex-nowrap align-items-center"
                 data-bs-toggle="tooltip" data-bs-placement="top" :data-bs-title="order.delivery_address">
              <svg class="bi fs-4 delete-product-ico" width="1.3rem" height="1.3rem" fill="purple">
                <use xlink:href="../../assets/ico/bootstrap-icons.svg#truck"/>
              </svg>
              <span class="ps-1">{{ $t('restOrders.delivery') }}</span>
            </div>
            <div v-else-if="order.delivery_method === 'pickup'" class="d-flex flex-nowrap align-items-center">
              <svg class="bi fs-4 delete-product-ico" width="1.3rem" height="1.3rem" fill="orange">
                <use xlink:href="../../assets/ico/bootstrap-icons.svg#person-video"/>
              </svg>
              <span class="ps-1">{{ $t('restOrders.takeaway') }}</span>
            </div>
            <div v-else>
              error
            </div>
          </td>
          <td>
            <div class="d-flex flex-nowrap align-items-center justify-content-start">
              <div class="input-group input-group-sm flex-nowrap w-auto me-1">
                <span :class="colorForStatus(order.history)" class="order-item__status input-group-text border-secondary border-end-0">{{ this.lastStatus(order.history) }}</span>
                <button type="button" class="btn btn-outline-secondary dropdown-toggle dropdown-toggle-split" data-bs-auto-close="true"  data-bs-toggle="dropdown" aria-expanded="false">
                  <span class="visually-hidden">Dropdown</span>
                </button>
                <ul class="dropdown-menu py-0" style="font-size: .8rem">
                  <li><a @click="changeStatus(order.id, 'created')" class="dropdown-item" href="#">{{ $t('restOrders.statuses.created') }}</a></li>
                  <li><a @click="changeStatus(order.id, 'accepted')" class="dropdown-item" href="#">{{ $t('restOrders.statuses.accepted') }}</a></li>
                  <li><a @click="changeStatus(order.id, 'preparing')" class="dropdown-item" href="#">{{ $t('restOrders.statuses.preparing') }}</a></li>
                  <li><a @click="changeStatus(order.id, 'ready')" class="dropdown-item" href="#">{{ $t('restOrders.statuses.ready') }}</a></li>
                  <li><a @click="changeStatus(order.id, 'delivering')" class="dropdown-item" href="#">{{ $t('restOrders.statuses.onTheWay') }}</a></li>
                  <li><a @click="changeStatus(order.id, 'completed')" class="dropdown-item" href="#">{{ $t('restOrders.statuses.done') }}</a></li>
                  <li><hr class="dropdown-divider my-1"></li>
                  <li><a @click="changeStatus(order.id, 'rejected')" class="dropdown-item text-danger" href="#">{{ $t('restOrders.statuses.cancelled') }}</a></li>
                </ul>
              </div>
              <div v-show="order.loading" class="spinner-border spinner-border-sm" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
          </td>
          <td>
            <svg data-bs-toggle="tooltip" data-bs-placement="left" data-bs-html="true"
                 :data-bs-title="orderHistoryTooltip(order.history)"
                class="bi fs-4 delete-product-ico" width="1.3rem" height="1.3rem" fill="currentColor">
              <use xlink:href="../../assets/ico/bootstrap-icons.svg#stopwatch"/>
            </svg>
          </td>
<!--          <td scope="col" class="text-end">-->
<!--            <button-->
<!--                @click="openOrder(order)"-->
<!--                class="btn btn-sm btn-outline-secondary pt-1">-->
<!--              <svg class="bi fs-4 delete-product-ico" width="1rem" height="1rem" fill="currentColor">-->
<!--                <use xlink:href="../../assets/ico/bootstrap-icons.svg#pencil-fill"/>-->
<!--              </svg>-->
<!--            </button>-->
<!--          </td>-->
        </tr>
        </tbody>
      </table>
    </div>
    <div class="text-center mb-4">
      <div class="btn-group btn-group-sm" role="group" aria-label="Orders pagination">
        <button @click="prevOrdersPage"
                :class="this.pageIndexSelect === 0 ? 'disabled' : ''"
                type="button" class="btn btn-outline-secondary">&lt;
        </button>
        <button v-for="(page, index) in ordersPages"
                @click="selectOrdersPage(index)"
                :class="index === this.pageIndexSelect ? 'btn-primary disabled' : 'btn-outline-secondary'"
                type="button" class="btn">{{index+1}}</button>
        <button v-show="!this.ORDER_PAGE_END"
                type="button" class="btn btn-outline-secondary disabled">...</button>
        <button @click="nextOrdersPage"
                :class="this.ORDER_PAGE_END && this.pageIndexSelect === this.ordersPages.length - 1 ? 'disabled' : ''"
                type="button" class="btn btn-outline-secondary">&gt;
        </button>
      </div>
    </div>
    <div class="modal fade" id="modalNewOrder" tabindex="-1" aria-labelledby="modalNewOrderLabel" aria-hidden="true">
      <div class="modal-dialog modal-sm modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header">
            <h1 class="modal-title fs-5" id="modalNewOrderLabel">{{newOrder.id}}</h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="text-center my-4">
              <h4>{{ $t('restOrders.newOrderReceived') }}</h4>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">{{ $t('restOrders.later') }}</button>
            <button
                @click="openOrder(newOrder)"
                data-bs-dismiss="modal"
                type="button" class="btn btn-success">{{ $t('restOrders.open') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import i18n from "@/i18n";
import router from "@/router"
import {Modal, Tooltip, Popover} from "bootstrap";
export default {
  name: "RestOrders",
  data() {
    return {
      newOrder: {},
      pullingTime: 30,
      pullingTimer: null,
      pageSize: 10,
      pageIndexSelect: 0,
    }
  },
  computed: {
    ...mapGetters([
      'RESTAURANT',
      'RESTAURANTORDERS',
      'LOADING',
      'ORDER_PULLING',
      'ORDER_PAGE_SIZE',
      'RESTAURANT_ORDERS_PAGES',
      'ORDER_PAGE_END',
    ]),
    ordersAreLoading() {
      return this.LOADING.orders
    },
    ordersPages() {
      return this.RESTAURANT_ORDERS_PAGES
    },
  },
  methods: {
    async getOrders(startKey = null) {
      let payload = {
        restId: this.$route.params.id,
        start_key: startKey
      }
      await this.$store.dispatch('getRestaurantOrders', payload)
    },
    updateOrders() {
      this.clearOrdersPage()
      // this.getOrders()
      this.pageIndexSelect = 0
      const startOrders = async () => {
        await this.getOrders()
      }
      startOrders().then( () => {
        if(this.RESTAURANT_ORDERS_PAGES[0].length > 0) {
          let firstOrder = this.RESTAURANT_ORDERS_PAGES[0][0]
          if (firstOrder.history.length === 1 && firstOrder.history[0].status === 'created') { //проверка на новый заказ
            this.newOrder = firstOrder
            this.openModalNewOrder()
          }
        }
      })
    },
    lastStatus(history) {
      let status = history[history.length - 1].status
      if (status === 'created') {return i18n.global.t('restOrders.statuses.created')}
      if (status === 'accepted') {return i18n.global.t('restOrders.statuses.accepted')}
      if (status === 'preparing') {return i18n.global.t('restOrders.statuses.preparing')}
      if (status === 'ready') {return i18n.global.t('restOrders.statuses.ready')}
      if (status === 'delivering') {return i18n.global.t('restOrders.statuses.onTheWay')}
      if (status === 'completed') {return i18n.global.t('restOrders.statuses.done')}
      if (status === 'rejected') {return i18n.global.t('restOrders.statuses.cancelled')}
    },
    colorForStatus(history) {
      let status = history[history.length - 1].status
      if (status === 'created') {return 'bg-black text-white'}
      if (status === 'accepted') {return 'bg-info text-white'}
      if (status === 'preparing') {return 'bg-warning'}
      if (status === 'ready') {return 'bg-success text-white'}
      if (status === 'delivering') {return 'bg-primary text-white'}
      if (status === 'completed') {return 'bg-gray-50'}
      if (status === 'rejected') {return 'bg-danger text-white'}
    },
    changeStatus(orderId, status) {
      this.$store.commit('addSpinnerToOrder', orderId)
      let restId = this.$route.params.id
      let requestBody = {
        'status': status,
        'comment': 'Fast change from orders list'
      }
      let payload = { restId, orderId, requestBody }
      const updateAllOrders = async () => {
        await this.$store.dispatch('addOrderStatus', payload)
      }
      updateAllOrders().then( () => {
        this.updateOrders()
      })
    },
    openOrder(order) {
      router.push({ name: 'RestOrdersItem', params: {orderId: order.id} })
    },
    friendlyTime(e) {
      let date = new Date(e)
      let options = {
        era: undefined,
        year: '2-digit',
        month: '2-digit',
        day: '2-digit',
        weekday: undefined,
        timezone: 'UTC',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric'
      };
      return date.toLocaleString("ru", options)
    },
    startTimer() {
      this.pullingTimer = setInterval(() => {
        this.pullingTime--
      }, 1000)
    },
    stopTimer() {
      clearTimeout(this.pullingTimer)
    },
    pullingChange() {
      this.$store.commit('setOrderPulling', !this.ORDER_PULLING)
    },
    clearOrdersPage() {
      this.$store.commit('clearRestaurantOrdersPages')
    },
    selectOrdersPage(index) {
      this.pageIndexSelect = index
    },
    prevOrdersPage() {
      this.pageIndexSelect--
    },
    nextOrdersPage() {
      if (!this.ORDER_PAGE_END) { // если страницы еще есть
        if (this.pageIndexSelect === this.ordersPages.length - 1) { //если сейчас выбрана не последняя страница, то
          const startOrders = async () => {
            await this.getOrders(this.$store.state.restaurantOrders.last_evaluated_key) // загружаем новую страницу с start_key
          }
          startOrders().then( () => {
            this.pageIndexSelect++ //переключаем страницу
          })
        } else {
          this.pageIndexSelect++ // просто переключаем страницу
        }
      } else if (this.pageIndexSelect <= this.ordersPages.length - 1) { // если страниц нет и сейчас выбрана не последняя страница
        this.pageIndexSelect++ // просто переключаем страницу
      }
    },
    openModalNewOrder() {
      const removeModal = new Modal(document.querySelector('#modalNewOrder'));
      let audio = new Audio();
      audio.src = require('../../assets/wav/new-order.wav');
      audio.autoplay = true;
      removeModal.show();
    },
    orderHistoryTooltip(history) {
      function time(e) {
        let date = new Date(e)
        let options = {
          hour: 'numeric',
          minute: 'numeric',
          second: 'numeric',
          timezone: 'UTC',
        };
        return date.toLocaleString("ru", options)
      }
      let tooltip = ''
      history.forEach((str) => {
        tooltip += `${str.status} ${time(str.datetime)}<br>`
      })
      return tooltip
    }
  },
  watch: {
    ORDER_PULLING(e) {
      if (e) {
        this.pullingTime = 30
        this.startTimer()
      } else {
        this.stopTimer()
      }
    },
    pullingTime(time) {
      if (time === 0) {
        this.pullingTime = 30
        this.updateOrders()
      }
    },
    pageSize(size) {
      this.$store.commit('setOrderPageSize', +size)
      this.updateOrders()
    },
  },
  created() {
    this.pageSize = this.ORDER_PAGE_SIZE
  },
  mounted() {
    this.clearOrdersPage()
    this.updateOrders()
    if (this.ORDER_PULLING) {
      this.startTimer()
    }
    //initialization bootstrap tooltips
    new Tooltip(document.body, {
      selector: "[data-bs-toggle='tooltip']",
    })
  }
}
</script>

<style scoped>

</style>
